var moduleMap = {
	"./handlers": () => {
		return Promise.all([__webpack_require__.e(558), __webpack_require__.e(237), __webpack_require__.e(593), __webpack_require__.e(95), __webpack_require__.e(231), __webpack_require__.e(305), __webpack_require__.e(155), __webpack_require__.e(849)]).then(() => (() => ((__webpack_require__(16507)))));
	},
	"./mountComponent": () => {
		return Promise.all([__webpack_require__.e(865), __webpack_require__.e(558), __webpack_require__.e(604), __webpack_require__.e(736), __webpack_require__.e(593), __webpack_require__.e(95), __webpack_require__.e(711), __webpack_require__.e(206), __webpack_require__.e(231), __webpack_require__.e(388), __webpack_require__.e(155), __webpack_require__.e(819), __webpack_require__.e(799)]).then(() => (() => ((__webpack_require__(56491)))));
	},
	"./mfeConfig": () => {
		return __webpack_require__.e(89).then(() => (() => ((__webpack_require__(67089)))));
	},
	"./clearQuery": () => {
		return Promise.all([__webpack_require__.e(865), __webpack_require__.e(156)]).then(() => (() => ((__webpack_require__(59156)))));
	},
	"./invalidateQueries": () => {
		return Promise.all([__webpack_require__.e(865), __webpack_require__.e(206), __webpack_require__.e(816)]).then(() => (() => ((__webpack_require__(47816)))));
	},
	"./backupPolicyUtils": () => {
		return __webpack_require__.e(819).then(() => (() => ((__webpack_require__(99819)))));
	},
	"./updateSecondaryAuthBackupsetApi": () => {
		return Promise.all([__webpack_require__.e(593), __webpack_require__.e(711), __webpack_require__.e(441)]).then(() => (() => ((__webpack_require__(49217)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});